import { createContext } from "react";

export const SitesAndActivityContext = createContext({});